import { SectionSkeleton } from '../common/SectionSkeleton';
import { ExpensesByGroupList } from './ExpensesByGroupList';
import { ExpensesSectionLabel } from './ExpensesSectionLabel';
import { ExpensesTypeDistributionChart } from './ExpensesTypeDistributionChart';
import pt from '../../locales/pt';

/**
 * Coluna direita do `.pen` (frames 768/1280) e blocos 2–3 no mobile:
 * «Distribuição por tipo» (donut) + «Onde está a ir» / «Grupos do método».
 * Tudo espaçado a `$space-5`, como o `content`/`col-right` do .pen.
 */
export function ExpensesBudgetMonitor({ overview, isLoading, hidden = false }) {
  const groups = overview?.groups || [];
  const hasIncome = Boolean(overview?.has_income);

  if (hidden) return null;

  const groupsHeading = (
    <ExpensesSectionLabel
      title={pt.expenses.sections.byGroup}
      desktopTitle={pt.expenses.sections.byGroupDesktop}
      hint={pt.expenses.sections.byGroupHint}
      tooltip={pt.expenses.sections.byGroupTooltip}
    />
  );

  if (isLoading) {
    return (
      <div className="flex w-full min-w-0 flex-col gap-space-5">
        <ExpensesTypeDistributionChart overview={null} isLoading />
        {groupsHeading}
        <SectionSkeleton variant="list" />
      </div>
    );
  }

  if (!overview || groups.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full min-w-0 flex-col gap-space-5 overflow-x-hidden">
      <ExpensesTypeDistributionChart overview={overview} isLoading={false} />
      {groupsHeading}
      <ExpensesByGroupList groups={groups} hasIncome={hasIncome} />
    </div>
  );
}
